import moment from 'moment';

const getMoment = (culture, value, format) => {
	return culture ? moment(value, format, true)['locale'](culture) : moment(value, format, true);
};

const endOfDecade = (date) => {
	return moment(date).add(10, 'year').add(-1, 'millisecond').toDate();
};

const endOfCentury = (date) => {
	return moment(date).add(100, 'year').add(-1, 'millisecond').toDate();
};

const localizer = {
	formats: {
		date: 'L',
		time: 'LT',
		default: 'lll',
		header: 'MMMM YYYY',
		footer: 'LL',
		weekday: 'dd',
		dayOfMonth: 'DD',
		month: 'MMM',
		year: 'YYYY',

		decade: (date, culture, localizer) => {
			return localizer.format(date, 'YYYY', culture)
				+ ' - ' + localizer.format(endOfDecade(date), 'YYYY', culture);
		},

		century: (date, culture, localizer) => {
			return localizer.format(date, 'YYYY', culture)
				+ ' - ' + localizer.format(endOfCentury(date), 'YYYY', culture);
		}
	},

	firstOfWeek: (culture) => {
		return moment.localeData(culture).firstDayOfWeek();
	},

	parse: (value, format, culture) => {
		if (!value) return null;
		const m = getMoment(culture, value, format);
		if (m.isValid()) return m.toDate();
		return null;
	},

	format: (value, format, culture) => {
		// convert from local time zone to currently selected time zone (configured for moment-timezone) keeping local time
		return getMoment(culture, [value.getFullYear(), value.getMonth(), value.getDate(), value.getHours(), value.getMinutes(), value.getSeconds(), value.getMilliseconds()]).format(format);
	}
};

export default localizer;